import { CircleAlert, FileText } from "lucide-react";
import type { AgenticProjection } from "../../../lib/agentic/task-api";

interface AgenticDraftCardsProps {
  projection: AgenticProjection | null;
}

export function AgenticDraftCards({ projection }: AgenticDraftCardsProps) {
  if (!projection) return null;
  const cards = buildCards(projection);
  if (cards.length === 0) return null;

  return (
    <div className="mb-2 flex gap-2 overflow-x-auto px-1">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.id}
            className="flex min-w-[168px] max-w-[220px] items-start gap-2 rounded-md border border-[var(--fintheon-accent)]/14 bg-[#0d0c09]/82 px-2.5 py-2"
          >
            <Icon className={card.tone} size={14} />
            <div className="min-w-0">
              <p className="truncate text-[11px] font-semibold text-[#f0ead6]/82">
                {card.title}
              </p>
              {card.detail ? (
                <p className="truncate text-[10px] text-[#f0ead6]/42">
                  {card.detail}
                </p>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function buildCards(projection: AgenticProjection) {
  const cards: Array<{
    id: string;
    title: string;
    detail: string;
    icon: typeof FileText;
    tone: string;
  }> = [];
  for (const approval of projection.pendingApprovals.slice(0, 2)) {
    cards.push({
      id: `approval-${approval.id}`,
      title: approval.title,
      detail: "approval waiting",
      icon: CircleAlert,
      tone: "mt-0.5 text-amber-300/80",
    });
  }
  for (const artifact of projection.draftArtifacts.slice(0, 3)) {
    cards.push({
      id: `artifact-${artifact.id}`,
      title: artifact.title,
      detail: artifact.artifactType,
      icon: FileText,
      tone: "mt-0.5 text-[#f0ead6]/48",
    });
  }
  return cards;
}
